export const ActionTypes = {
  LOADING: "AREA_LOADING",
  ERROR: "AREA_ERROR",
  SUCCESS: "AREA_SUCCESS",
};
